// extracted by mini-css-extract-plugin
module.exports = {"container":"SectionTitle-module--container--NPtch","text":"SectionTitle-module--text--21ulu","line":"SectionTitle-module--line--1l-MQ"};